var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.187 97.7693C704.191 134.334 747.528 183.218 777.477 240.223L425.264 425.264L651.187 97.7693Z",
    fill: "url(#paint0_linear_90_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.062 30.2836C536.989 38.0196 598.082 61.1561 651.096 97.7064L425.264 425.264L473.062 30.2836Z",
    fill: "url(#paint1_linear_90_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M777.853 609.592C748.02 666.658 704.782 715.629 651.852 752.301L425.266 425.264L777.853 609.592Z",
    fill: "url(#paint2_linear_90_24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M823.128 425.264C823.128 489.657 807.499 553.087 777.582 610.109L425.266 425.264H823.128Z",
    fill: "url(#paint3_linear_90_24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M777.529 240.321C807.462 297.334 823.109 360.76 823.127 425.153L425.265 425.264L777.529 240.321Z",
    fill: "url(#paint4_linear_90_24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M651.759 752.364C598.818 789.022 537.772 812.282 473.861 820.147L425.264 425.264L651.759 752.364Z",
    fill: "url(#paint5_linear_90_24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.743 689.416C84.9912 641.263 54.5656 583.453 39.0792 520.95L425.264 425.264L127.743 689.416Z",
    fill: "url(#paint6_linear_90_24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.63 797.442C224.394 774.681 170.583 737.64 127.818 689.499L425.264 425.264L284.63 797.442Z",
    fill: "url(#paint7_linear_90_24)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M473.752 820.161C409.84 828.008 344.977 820.226 284.735 797.481L425.265 425.264L473.752 820.161Z",
    fill: "url(#paint8_linear_90_24)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.981 53.3327C344.177 30.4664 409.024 22.5525 472.953 30.2706L425.265 425.265L283.981 53.3327Z",
    fill: "url(#paint9_linear_90_24)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.283 161.633C169.951 113.405 223.688 76.255 283.877 53.3718L425.265 425.264L127.283 161.633Z",
    fill: "url(#paint10_linear_90_24)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8866 330.361C54.2464 267.827 84.555 209.955 127.21 161.716L425.264 425.265L38.8866 330.361Z",
    fill: "url(#paint11_linear_90_24)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0516 520.842C23.5826 458.335 23.5165 393.007 38.8589 330.469L425.263 425.265L39.0516 520.842Z",
    fill: "url(#paint12_linear_90_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_24",
    x1: 538.085,
    y1: 203.971,
    x2: 711.284,
    y2: 352.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_24",
    x1: 422.29,
    y1: 176.889,
    x2: 644.911,
    y2: 228.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_24",
    x1: 706.358,
    y1: 520.773,
    x2: 484.764,
    y2: 679.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_24",
    x1: 676.416,
    y1: 416.36,
    x2: 602.934,
    y2: 634.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_24",
    x1: 643.493,
    y1: 300.635,
    x2: 679.849,
    y2: 527.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_24",
    x1: 575.559,
    y1: 626.677,
    x2: 354.356,
    y2: 690.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_24",
    x1: 262.913,
    y1: 613.258,
    x2: 130.262,
    y2: 427.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_24",
    x1: 344.818,
    y1: 663.349,
    x2: 166.702,
    y2: 517.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_24",
    x1: 487.82,
    y1: 665.652,
    x2: 259.361,
    y2: 669.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_24",
    x1: 307.176,
    y1: 206.737,
    x2: 528.193,
    y2: 148.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_24",
    x1: 227.635,
    y1: 283.2,
    x2: 430.866,
    y2: 150.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_90_24",
    x1: 128.067,
    y1: 438.661,
    x2: 306.457,
    y2: 178.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_90_24",
    x1: 183.606,
    y1: 494.241,
    x2: 202.525,
    y2: 264.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors13);
export default __webpack_public_path__ + "static/media/sectors-13.05f06a5fce4c40e019f5412ad6151198.svg";
export { ForwardRef as ReactComponent };